import React from 'react'

export const DriverHintText = () => (
  <>
    ВОДИТЕЛЬ
    <br />
    <ul>
      <li>паспорт</li>
      <li>водительское удостоверение</li>
    </ul>
  </>
)

export default DriverHintText
